export default __webpack_public_path__ + "static/media/corporate.1524bb37.svg";